import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SDM17DEC from './SDM17DEC';
import BasicForm from './BasicForm';

class SensorDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        const { moduleType } = this.props;
        const detailContentByType = {
            SDM17DEC: () => <SDM17DEC {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default SensorDetail;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/DriveElec/index.js